import {DraftAssignmentModelV1} from 'resources/GeneratedModels/DraftAssignment/DraftAssignmentModel.v1';

import {draftAssignmentExtensions} from './draftAssignment.extensions';

DraftAssignmentModelV1.extend(draftAssignmentExtensions);

export {DraftAssignmentModelV1};
